/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-array-index-key */
import { QuestionComponentProps } from '../../type';
import CombineChildQuestion from './components/CombineChildQuestion';
import { HeaderCommon, QuestionText } from '../RenderCommon';

const Combine = ({ questionIndex, questionData }: QuestionComponentProps) => {
  const { questionText, answers, imageUrl } = questionData;
  const renderChildQuestion = () => {
    return <div>{Array.isArray(answers) && answers.map((item, index) => <CombineChildQuestion key={index} questionIndex={index} questionData={item} isCombineChild />)}</div>;
  };

  return (
    <div>
      <HeaderCommon key={questionData.id} questionIndex={questionIndex} questionData={questionData} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>{imageUrl ? <img src={imageUrl} style={{ maxHeight: 200 }} /> : null}</div>
      <div style={{ marginBottom: 5 }}>
        <QuestionText key={questionIndex} questionText={questionText} />
      </div>
      <div>{renderChildQuestion()}</div>
    </div>
  );
};

export default Combine;
